import { useEffect, useState, Suspense, lazy } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PreLoader from "../../components/preloader/PreLoader";
const VisaServices = lazy(() => import("../../pages/typesofvisa/typesOfVisa/typesOfVisa"));
const ServiceDetailPage = lazy(() => import("../serviceDetails/ServiceDetailPage"));
const DepartmentPages = lazy(() => import("../Department/DepartmentPages"));

const apiUrl = import.meta.env.VITE_API_URL;

import { getFooterPageTypeBySlug } from "../../lib/api";
import { useCart } from "../../hooks/useCart";

const ConditionalComponent = () => {
  const { getData } = useCart();
  const { slugUrl } = useParams();
  const navigate = useNavigate();

  const [pageType, setPageType] = useState<"visa" | "department" | "new-visa" | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slugUrl) return;
    getData()

    const fetchPageType = async () => {
      setLoading(true);

      try {
        const dataUrl = `${apiUrl}/api/footer-pages/check-page-type/${slugUrl}`;
        const data = await getFooterPageTypeBySlug(dataUrl);
        
        if (["new-visa", "visa", "department", "service"].includes(data?.type)) {
          setPageType(data.type);
          window.sessionStorage.setItem("isLoad", '0');
        } else {
          navigate("/notFound");
        }
      } catch (error) {
        navigate("/notFound");
      } finally {
        setLoading(false);
      }
    };

    fetchPageType();
  }, [slugUrl, navigate]);

  if (loading || pageType === null) return <PreLoader />;

  return (
    <Suspense fallback={<PreLoader />}>
      {pageType === "visa" && <VisaServices />}
      {["new-visa", "service"].includes(pageType) && <ServiceDetailPage />}
      {pageType === "department" && <DepartmentPages />}
    </Suspense>
  );
};

export default ConditionalComponent;
